import { isWeb } from '../src/utils/platformUtils'
import DatabaseSingleton from '../database-sqlite/DatabaseSingleton'

export const TABLE_ERROR_LOGS = 'error_logs'

// ✅ Importar getRealDatabase desde DatabaseSingleton (única fuente de verdad)
import { getRealDatabase } from '../database-sqlite/DatabaseSingleton'

class _ErrorServices {
    constructor() {
        // Todos los métodos usan getRealDatabase() directamente
    }

    getErrorLogs = async () => {
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                resolve([])
                return
            }

            try {
                const realDb = await getRealDatabase()
                const logs = await realDb.getAllAsync(`SELECT * FROM ${TABLE_ERROR_LOGS}`)
                resolve(logs || [])
            } catch (error) {
                console.error('getErrorLogs error:', error)
                reject(error)
            }
        })
    }

    addErrorLog = async (dataError) => {
        console.log('56 --- addErrorLog: Error log', dataError)
        return new Promise(async (resolve, reject) => {
            console.log('Error log', dataError)
            const {user_id, log, date, connect_status, endpoint, additional} = dataError

            if (isWeb()) {
                resolve([])
                return
            }

            try {
                const realDb = await getRealDatabase()
                const result = await realDb.runAsync(
                    `INSERT INTO ${TABLE_ERROR_LOGS} 
                    (
                        user_id,
                        log,
                        date,
                        connect_status,
                        endpoint,
                        additional
                    ) 
                    VALUES (?, ?, ?, ?, ?, ?)`,
                    [user_id, log, date, connect_status, endpoint, additional]
                )
                console.log('80 -- registro insertado con exito: ', result.lastInsertRowId)
                resolve(result.lastInsertRowId)
            } catch (error) {
                console.error('addErrorLog error:', error)
                reject(error)
            }
        })
    }

    deleteRegistersErrorLogs = async () => {
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                resolve([])
                return
            }

            try {
                const realDb = await getRealDatabase()
                await realDb.runAsync(`DELETE FROM ${TABLE_ERROR_LOGS}`)
                resolve([])
            } catch (error) {
                console.error('deleteRegistersErrorLogs error:', error)
                reject(error)
            }
        })
    }
}

export const ErrorServices = new _ErrorServices()
